import { render, staticRenderFns } from "./EHSCatalogSidebar.vue?vue&type=template&id=0e6d3f08&scoped=true"
import script from "./EHSCatalogSidebar.vue?vue&type=script&lang=js"
export * from "./EHSCatalogSidebar.vue?vue&type=script&lang=js"
import style0 from "./EHSCatalogSidebar.vue?vue&type=style&index=0&id=0e6d3f08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6d3f08",
  null
  
)

export default component.exports